import Actions from '../../base/actions';
import user from './User';
import formNewChanges from './FormNewChanges'

const actions: Actions = {
  user,
  formNewChanges
};

export default actions;
